<section class="widget-container">
    <!-- The container can hold an Apex chart, a table with aggregated data, or any other relevant information as required -->
  @if (!isNoContent) {
    <ng-content></ng-content>
  }
  @if (loading) {
    <div class="spinner-container">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  }
</section>